/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

// Module to make the Foundation api injectable.  Using capital 'Foundation' to match foundation docs/examples.
angular.module('foundationModule', [])
.factory('Foundation', ['$window', FoundationFactory]);

function FoundationFactory($window) {
  return $window.Foundation;
}
